/**
 * 인간 가동 확인 modal (계획서 §12.5, §14 단계 7-4).
 *
 * PLC 로 보내는 것은 `effective_at` schedule 이 아니라 **현재 최종 목표**뿐이다 (§12.5).
 * double click 은 새 message 를 만들지 않고 같은 `message_id` 를 돌려준다.
 */

import type { CandidatePayload, StrategyCode } from "@/types/api";
import { formatTime, withUnit } from "@/lib/format";

interface Props {
  open: boolean;
  strategy: StrategyCode | null;
  candidate: CandidatePayload | null;
  busy: boolean;
  messageId: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export function HumanStartModal({
  open,
  strategy,
  candidate,
  busy,
  messageId,
  onConfirm,
  onClose,
}: Props): React.JSX.Element | null {
  if (!open) return null;

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="human-start-title"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <h2 id="human-start-title">설비 가동 확인</h2>

        {messageId ? (
          <>
            <p role="status">
              PLC 로 가동 지시를 보냈습니다. message_id <code>{messageId}</code>
            </p>
            <p className="hint">같은 버튼을 다시 눌러도 새 message 를 만들지 않습니다 (§12.5)</p>
            <div className="row">
              <button type="button" onClick={onClose}>
                닫기
              </button>
            </div>
          </>
        ) : (
          <>
            <p>
              {strategy ?? "?"}안으로 건조기·집진기·컴프레서를 가동합니다. 되돌릴 수 없습니다.
            </p>
            {candidate && (
              <dl className="modal-targets">
                <div>
                  <dt>건조기 기동</dt>
                  <dd>{formatTime(candidate.dryer_started_at)}</dd>
                </div>
                <div>
                  <dt>READY</dt>
                  <dd>{formatTime(candidate.ready_at)}</dd>
                </div>
                <div>
                  <dt>첫 제품 ETA</dt>
                  <dd>{formatTime(candidate.first_batch_eta)}</dd>
                </div>
                <div>
                  <dt>최종 변화율</dt>
                  <dd>{withUnit(candidate.final_change_pct, "%")}</dd>
                </div>
              </dl>
            )}
            <div className="row">
              <button type="button" className="primary" onClick={onConfirm} disabled={busy}>
                가동
              </button>
              <button type="button" className="secondary" onClick={onClose} disabled={busy}>
                취소
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
